import { Share2, Link as LinkIcon, Mail, Send, MessageCircle, Facebook } from "lucide-react";
import { toast } from "sonner";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const targets = (url, text) => {
  const u = encodeURIComponent(url);
  const t = encodeURIComponent(text);
  return [
    ["whatsapp", "WhatsApp", MessageCircle, `https://wa.me/?text=${t}%20${u}`],
    ["facebook", "Facebook", Facebook, `https://www.facebook.com/sharer/sharer.php?u=${u}`],
    ["telegram", "Telegram", Send, `https://t.me/share/url?url=${u}&text=${t}`],
    ["x", "X (Twitter)", Share2, `https://twitter.com/intent/tweet?url=${u}&text=${t}`],
    ["email", "Email", Mail, `mailto:?subject=${t}&body=${t}%20${u}`],
  ];
};

export const ShareButton = ({ path = "/", text = "Guarda le offerte del giorno su Sconto.Market", label = "Condividi", testid = "share-button", className = "" }) => {
  const url = `${window.location.origin}${path}`;

  const nativeShare = async (e) => {
    if (navigator.share && window.matchMedia("(pointer: coarse)").matches) {
      e.preventDefault();
      try { await navigator.share({ title: "Sconto.Market", text, url }); } catch { /* chiuso dall'utente */ }
    }
  };
  const copy = async () => {
    await navigator.clipboard.writeText(url);
    toast.success("Link copiato");
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" onClick={nativeShare} data-testid={testid} className={`btn-ghost h-10 px-2 sm:px-3 flex items-center gap-2 text-sm ${className}`}>
          <Share2 size={18} strokeWidth={1.5} /> <span className="hidden sm:inline">{label}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-56 p-0 rounded-none border border-[#0F0F0F]" data-testid={`${testid}-menu`}>
        <p className="tag px-4 py-3 border-b border-[#0F0F0F]">Condividi con</p>
        {targets(url, text).map(([id, name, Icon, href]) => (
          <a key={id} href={href} target="_blank" rel="noreferrer" data-testid={`${testid}-${id}`}
            className="flex items-center gap-3 px-4 py-2.5 text-sm hover:bg-[#0F0F0F] hover:text-white">
            <Icon size={16} strokeWidth={1.5} /> {name}
          </a>
        ))}
        <button type="button" onClick={copy} data-testid={`${testid}-copy`}
          className="w-full flex items-center gap-3 px-4 py-2.5 text-sm border-t border-[#0F0F0F] hover:bg-[#FF3333] hover:text-white">
          <LinkIcon size={16} strokeWidth={1.5} /> Copia link
        </button>
      </PopoverContent>
    </Popover>
  );
};
